import { createFileRoute } from '@tanstack/react-router';
import { AccountPage } from '@/features/portal/AccountPage';

export const Route = createFileRoute('/portal/_portal/account')({
  component: AccountRoute,
});

function AccountRoute() {
  const { me } = Route.useRouteContext();
  return <AccountPage me={me} />;
}
